import { useNavigation } from '@react-navigation/core';
import { Button, Headline1, Meta } from 'aimo-ui';
import { Center } from 'components/park/styles/styles';
import { useTranslation } from 'react-i18next';
import { StyledWrapper } from 'styles/ContainerStyles';
import { AccountNavProps } from 'types/navigation';

const EmptyView = () => {
  const { t } = useTranslation();
  const { goBack, canGoBack, navigate } = useNavigation<AccountNavProps>();
  const handleBack = () => {
    if (canGoBack()) {
      goBack();
    } else {
      navigate('accountMain');
    }
  };
  return (
    <Center>
      <StyledWrapper center mt={80}>
        <StyledWrapper center mb={30}>
          <Headline1 center testID="city-pmcs-not-found-title">
            {t('account.aimoSubscription.notFound')}
          </Headline1>
        </StyledWrapper>
        <StyledWrapper center mb={40}>
          <Meta testID="city-pmcs-not-found-meta" center>
            {t('account.aimoSubscription.notFoundDescription')}
          </Meta>
        </StyledWrapper>

        <StyledWrapper center maxWidth={400}>
          <Button size="l" onPress={handleBack} text={t('ariaLabels.goBack')} />
        </StyledWrapper>
      </StyledWrapper>
    </Center>
  );
};

export default EmptyView;
